<template>
  <div id="forms">
    <div id="forms-title">
      <h1>Forms</h1>
      <a-select
        :default-value="currentPathType"
        class="select-processor"
        @change="changeViewedMappingType"
      >
        <a-select-option
          v-for="mappingType in mappingTypes"
          :key="mappingType.value"
        >{{ mappingType.name }}</a-select-option>
      </a-select>
      <router-link to="/add-form" tag="a-button">Add New</router-link>
      <a-button
        class="delete-btn"
        @click="deleteForms()"
        :disabled="loading || selectedRows.length == 0"
      >Delete</a-button>
      <a-button @click="loadForms()" :disabled="loading">
        <a-icon type="sync" />
      </a-button>
    </div>

    <router-view
      ref="selectedMappingType"
      :selectedRows="selectedRows"
      :setSelectedRows="setSelectedRows"
      :loading="loading"
      :setLoading="setLoading"
    ></router-view>

    <a-spin size="large" v-if="loading"></a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      currentPath: null,
      loading: true,
      selectedRows: [],
      mappingTypes: [
        { name: "Facebook", value: "facebook" },
        { name: "Google/Other", value: "google" },
        { name: "Snapchat", value: "snapchat" }
      ]
    };
  },
  computed: {
    ...mapState(["user", "apiUrl"])
  },
  methods: {
    changeViewedMappingType(value) {
      this.$router.replace(`/forms/${value}`);
    },
    setLoading(value) {
      this.loading = value;
    },
    setSelectedRows(value) {
      this.selectedRows = value;
    },
    loadForms() {
      this.$refs.selectedMappingType.loadForms();
    },
    deleteForms() {
      this.$refs.selectedMappingType.deleteForms();
    }
  },
  created() {
    // currentPathType = 'facebook' or 'google'
    // Note that when going to the homepage (which then redirects to the /forms/facebook page),
    // the $route.path is empty. So we need to prepare for it and use 'facebook' as default.
    this.currentPathType = this.$route.path.split("/").pop();
    if (!this.currentPathType) {
      this.currentPathType = "facebook";
    }
  }
};
</script>

<style lang="scss" scoped>
#forms-title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  h1 {
    margin: 0 10px 0 0;
  }
  .delete-btn {
    margin: 0 10px;
  }

  .select-processor {
    width: 150px;
    margin: 0 10px;
  }
}
</style>